import { Controller } from "@hotwired/stimulus"

// Theme preset cards for the music-theory-short Style step. Each preset radio
// carries the palette as data-colors JSON; picking one fills the colour inputs
// and fires `input` on each so the live preview (music-theory-preview) refreshes.
// The colour inputs stay fully editable afterwards — a preset is a starting
// point, not a lock.
export default class extends Controller {
  static targets = ["accent", "accent2", "bg", "bg2", "textColor"]

  apply(event) {
    let colors
    try {
      colors = JSON.parse(event.target.dataset.colors || "{}")
    } catch (_error) {
      return
    }

    this.fill(this.hasAccentTarget && this.accentTarget, colors.accent)
    this.fill(this.hasAccent2Target && this.accent2Target, colors.accent2)
    this.fill(this.hasBgTarget && this.bgTarget, colors.bg)
    this.fill(this.hasBg2Target && this.bg2Target, colors.bg2)
    this.fill(this.hasTextColorTarget && this.textColorTarget, colors.text_color)
  }

  fill(input, value) {
    if (!input || !value) return
    input.value = value
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
